module.exports = __webpack_public_path__ + "img/5-4.6e458e41.jpg";